import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';

import { ALERT_NOTIFICATION_VERSION } from '@lib/axon/services/alerts.constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[sn-cad-high-priority-toast]',
  templateUrl: './cad-high-priority-toast.component.html',
  styleUrls: ['./cad-high-priority-toast.component.scss'],
  preserveWhitespaces: false,
  animations: [
    trigger('flyInOut', [
      state(
        'inactive',
        style({
          opacity: 0,
        }),
      ),
      transition(
        'inactive => active',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
              opacity: 0,
            }),
            style({
              transform: 'skewX(20deg)',
              opacity: 1,
            }),
            style({
              transform: 'skewX(-5deg)',
              opacity: 1,
            }),
            style({
              transform: 'none',
              opacity: 1,
            }),
          ]),
        ),
      ),
      transition(
        'active => removed',
        animate(
          '400ms ease-out',
          keyframes([
            style({
              opacity: 1,
            }),
            style({
              transform: 'translate3d(100%, 0, 0) skewX(30deg)',
              opacity: 0,
            }),
          ]),
        ),
      ),
    ]),
  ],
})
export class CadHighPriorityToastComponent extends Toast {
  cxVersion?: string;
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
    this.cxVersion = ALERT_NOTIFICATION_VERSION.LEGACY_CX;
  }
}
